import ApiConstant from "../../constants/api.constants";
import api from "../api";
import { ProductCheckoutProceedModel,OpenOrderSearchDTO } from "../../models/products/product-checkout-proceed-model";
import {
  MapOrderData,
  AdminMapOrderData,
} from "../../models/orders/order-mapper-model";

const tenantGuid = process.env.REACT_APP_TENAT_ID;

const setCustomerOrder = async (order: ProductCheckoutProceedModel) => {
  try {
    let data = MapOrderData(order);
    return await api
      .post(ApiConstant.setCustomerOrder, data, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  } catch {
    console.log("error in customer placing order");
  }
};

const setAdminCustomerOrder = async (
  order: ProductCheckoutProceedModel,
  selectedAdminUserId: number
) => {
  try {
    let data = AdminMapOrderData(order, selectedAdminUserId);
    return await api
      .post(ApiConstant.setAdminCustomerOrder, data, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  } catch {
    console.log("error in customer placing order");
  }
};

const setOrderDeliveryDate = async ( orderID: any,expectedDeliveryDate: any) => {
  try {
    const response = await api.put(ApiConstant.changeOrderDeliveryDate, {
      orderID,
      expectedDeliveryDate,
    }, {
      headers: {
        "content-type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in customer placing order:", error);
    throw error; // Optional: Rethrow error to be handled elsewhere
  }
};

const updatePendingQuantityOfOrderDetail = async (
  orderDetailID: number,
  quantity: number,
  pendingQuantity: number
) => {
  const pendingQuantityUpadate: { 
    orderDetailID: number,
    quantity: number,
    pendingQuantity: number} = {orderDetailID:orderDetailID,quantity:quantity,pendingQuantity:pendingQuantity};
  try {
    return await api
      .put(ApiConstant.updatePendingQuantity, pendingQuantityUpadate, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  } catch {
    console.log("error in pending quantity update");
  }
};

const setOrderFromCustomer = async (
  order: ProductCheckoutProceedModel,
) => {
  try {
    let data = MapOrderData(order);
    return await api
      .post(ApiConstant.createOrderFormCustomer, data, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  } catch {
    console.log("error in customer placing order");
  }
};

const setOrderForCustomer = async (
  order: ProductCheckoutProceedModel,
  selectedAdminUserId: number
) => {
  try {
    let data = AdminMapOrderData(order, selectedAdminUserId);
    return await api
      .post(ApiConstant.createOrderForCustomer, data, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  } catch {
    console.log("error in customer placing order");
  }
};

export const searchOrdersById = async (searchOrderId: number) => {
  try {
    const response = await api.post(ApiConstant.searchorders, {
      searchOrderId: searchOrderId,
    }, {
      headers: {
        "Content-Type": "application/json",
      },
    });
 
    return response.data;
  } catch (error) {
    console.error("Error searching orders:", error);
    throw error;
  }
}

export const getOpenOrderUserAddresses = async (request: OpenOrderSearchDTO) => {
  try {
    const response = await api.post(ApiConstant.getOpenOrderUserAddresses, request, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data; // This will be { totalRecords, addresses }
  } catch (error) {
    console.error("Error fetching open order user addresses:", error);
    throw error;
  }
};

const OrderService = {
  setCustomerOrder,
  setAdminCustomerOrder,
  setOrderDeliveryDate,
  updatePendingQuantityOfOrderDetail,
  setOrderFromCustomer,
  setOrderForCustomer,
  searchOrdersById,
  getOpenOrderUserAddresses
};

export default OrderService;
